import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useSpring, animated, config } from "@react-spring/three";

export function VuseUltraBlue({color}) {
  const { nodes, materials } = useGLTF('/data/VuseUltraAll.glb')

  const springBlack = useSpring({opacity: color === "black" ? 1 : 0, config: config.stiff, delay: color !== "black" ? 100 : 0});
  const springBlue = useSpring({opacity: color === "blue" ? 1 : 0, config: config.stiff, delay: color !== "blue" ? 100 : 0});
  const springPink = useSpring({opacity: color === "pink" ? 1 : 0, config: config.stiff, delay: color !== "pink" ? 100 : 0});

  return (
    <group dispose={null}>
      <group position={[-0.993, 0.447, -0.022]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh002.geometry}
          material={materials.metal}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh002_1.geometry}
          material={materials.Material}
        />
      </group>
      <group position={[-1.129, 7.716, -0.237]} rotation={[Math.PI / 2, -1.571, 0]} scale={0.962}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh003.geometry}
          material={materials.mat_ustnik}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh003_1.geometry}
          material={materials['Material #32.002']}
        />
      </group>
      <animated.mesh
        castShadow
        receiveShadow
        geometry={nodes.vuse_body_bez_ekranui_colapse.geometry}
        material={materials['vuse body']}
        position={[1.42, -0.996, 0]}
        material-transparent
        material-opacity={springBlack.opacity}
      />
      <animated.mesh
        castShadow
        receiveShadow
        geometry={nodes.vuse_body_bez_ekranui_colapse.geometry}
        material={materials['vuse body.001']}
        position={[1.42, -0.996, 0]}
        material-transparent
        material-opacity={springBlue.opacity}
      />
      <animated.mesh
        castShadow
        receiveShadow
        geometry={nodes.vuse_body_bez_ekranui_colapse.geometry}
        material={materials['vuse body.002']}
        position={[1.42, -0.996, 0]}
        material-transparent
        material-opacity={springPink.opacity}
      />
    </group>
  )
}